import type { LucideIcon } from 'lucide-react'
import { Badge } from '@/components/ui/Badge'

/** The box a navigation card sits in (put it on a router <Link>). */
export const navCardClass =
  'group flex min-h-[72px] items-start gap-3 rounded-card border border-line bg-surface p-4 shadow-card transition-colors hover:border-brand'

/** What is inside a navigation card: its icon, name, what it is for, and a live figure where there is one. */
export function NavCardFace({
  icon: Icon,
  title,
  description,
  live,
  attention,
}: {
  icon: LucideIcon
  title: string
  description: string
  /** e.g. "2 waiting". Undefined while loading or when there is nothing live to say. */
  live?: string
  attention?: boolean
}) {
  return (
    <>
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-control bg-brand-tint text-brand-ink" aria-hidden>
        <Icon size={18} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center justify-between gap-2">
          <span className="text-card font-semibold text-ink">{title}</span>
          {live && <Badge tone={attention ? 'warning' : 'neutral'}>{live}</Badge>}
        </span>
        <span className="mt-0.5 block text-body text-muted">{description}</span>
      </span>
    </>
  )
}
